import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import AdGenerator from "@/pages/AdGenerator";
import LeadCapture from "@/pages/LeadCapture";
import LeadsManagement from "@/pages/LeadsManagement";
import Templates from "@/pages/Templates";
import Settings from "@/pages/Settings";
import AdminLogin from "@/pages/AdminLogin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public lead funnel - root domain */}
          <Route path="/" element={<LeadCapture />} />
          <Route path="/apply" element={<LeadCapture />} />
          <Route path="/capture" element={<LeadCapture />} />
          
          {/* Admin login */}
          <Route path="/login" element={<AdminLogin />} />
          
          {/* Protected admin routes */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="generator" element={<AdGenerator />} />
            <Route path="leads" element={<LeadsManagement />} />
            <Route path="templates" element={<Templates />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
